
   <div class="row" *ngIf="!isPostgraduateStudent()">
      <div class="col-md-12">
        <div class="tile">
          <h4>Note: As you fill your application, you will see an indicator showing incomplete (0-90%) to Complete (100%)
          </h4>

        </div>
      </div>

    </div>

     <div class="row" *ngIf="!isPostgraduateStudent()">

          <div class="col-md-6 col-lg-3">
            <div class="widget-small primary coloured-icon"><i class="icon fa fa-camera fa-3x"></i>
              <div class="info">
                <h4>Picture Uploading</h4>
                <p><b>{{imageUploadMessage?.message}}</b></p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="widget-small info coloured-icon"><i class="icon fa fa-pencil-square-o fa-3x"></i>
              <div class="info">
                <h4>Personal Info</h4>
                <p><b>{{personalMessage?.message}}</b></p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="widget-small warning coloured-icon"><i class="icon fa fa-certificate fa-3x"></i>
              <div class="info">
                <h4>Past Examination RESULT</h4>
                <p><b>{{examinationMessage?.message}}</b></p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="widget-small danger coloured-icon"><i class="icon fa fa-list-ol fa-3x"></i>
              <div class="info">
                <h4>Programme Choice</h4>
                <p><b>{{programmeMessage?.message}}</b></p>
              </div>
            </div>
          </div>
        </div>


        <div class="row">


          <!-- <div class="col-md-12">
            <div class="tile">
              <h3 class="tile-title">Subscribe</h3>
              <div class="tile-body">
                <form class="row">
                  <div class="form-group col-md-3">
                    <label class="control-label">Name</label>
                    <input class="form-control" type="text" placeholder="Enter your name">
                  </div>
                  <div class="form-group col-md-3">
                    <label class="control-label">Email</label>
                    <input class="form-control" type="text" placeholder="Enter your email">
                  </div>
                  <div class="form-group col-md-4 align-self-end">
                    <button class="btn btn-primary" type="button"><i class="fa fa-fw fa-lg fa-check-circle"></i>Subscribe</button>
                  </div>
                </form>
              </div>
            </div>
          </div> -->

        </div>



        <div class="row">
          <div class="col-md-6">
            <div class="tile">
              <h3 class="tile-title">Notices</h3>
              <ul>
                <li>Please do not enter any information in the optional areas of the form if you have none</li>
                <li>Provide a valid Name</li>
                <li>Provide an active phone number and email address</li>
                <!-- <li>Smart integration of forgot password on login page</li>
                <li>Chart.js integration to display responsive charts</li>
                <li>Widgets to effectively display statistics</li>
                <li>Data tables with sort, search and paginate functionality</li>
                <li>Custom form elements like toggle buttons, auto-complete, tags and date-picker</li>
                <li>A inbuilt toast library for providing meaningful response messages to user's actions</li> -->
              </ul>
              <!-- <p>Vali is a free and responsive admin theme built with Bootstrap 4, SASS and PUG.js. It's fully customizable and modular.</p>
              <p>Vali is is light-weight, expendable and good looking theme. The theme has all the features required in a dashboard theme but this features are built like plug and play module. Take a look at the <a href="http://pratikborsadiya.in/blog/vali-admin" target="_blank">documentation</a> about customizing the theme colors and functionality.</p>
              <p class="mt-4 mb-4"><a class="btn btn-primary mr-2 mb-2" href="http://pratikborsadiya.in/blog/vali-admin" target="_blank"><i class="fa fa-file"></i>Docs</a><a class="btn btn-info mr-2 mb-2" href="https://github.com/pratikborsadiya/vali-admin" target="_blank"><i class="fa fa-github"></i>GitHub</a><a class="btn btn-success mr-2 mb-2" href="https://github.com/pratikborsadiya/vali-admin/archive/master.zip" target="_blank"><i class="fa fa-download"></i>Download</a></p> -->
            </div>
          </div>
          <div class="col-md-6">
            <div class="tile">
              <h3 class="tile-title">{{applicantData.ApplicationType}}</h3>
              <button class="btn btn-primary waves-effect waves-light m-1 " (click)="onStart()">Start</button>
            </div>
          </div>
        </div>

        <div class="row">
            <div class="col-md-12">
              <div class="tile">
                <h3 class="tile-title">Applicant Name:  {{applicantData.ApplicatantFullName}}</h3>
                <ul>
                    <li class="text-danger">Please check and make sure your name is valid</li>
                </ul>
              </div>
            </div>

          </div>
